import styled from "styled-components";

export const MainDiv=styled.div`
    width: 100%;
`
export  const LineDiv=styled.div`
    display: flex;
`
export  const Text=styled.p`    
    margin: 0px;
`
export const ButtonsDiv=styled.div`
    width: 80%;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    display: ${props=>props.visible};
`
export  const SelectorsDiv=styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
    width:90%;
    height:20px;
    display: grid;
    grid-template-columns: repeat(3, auto);
    display: ${props=>props.visible};
`
export  const SelectorDiv=styled.div`
    cursor: pointer;
    text-align: center;
    width: 90%;
    height:100%;
    border: solid 1px black;
    background-color: ${props=>props.background};;
`
export const  SectionDiv=styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    width: 90%;
    display: grid;
    grid-template-columns:1fr  1fr 1fr;
    gap: 10px;
    border: black 1px solid;
    pointer-events: ${props=>props.clickable};
    display: ${props=>props.visible};
    @media (max-width: ${props=>props.screenWidth}) {
        grid-template-columns:1fr  1fr;
    }

`
export const Button=styled.button`
    margin-right: 20px;
`